import * as C from '../styles';

import PanelOptionMixin from '../mixin';

import ComboChart from '@svgIcons/combo_chart.svg';

export const OnOffSetting = {
    name: 'OnOffOption',
    mixins: [PanelOptionMixin],
    props: {
        hideGraph: {
            type: Boolean,
            default: false,
        },
    },
    render() {
        const { hideGraph } = this;

        return (
            <C.ComponentWrapper hasContent={false}>
                {this.wrapOptions({
                    children: <div></div>,
                    title: this.$t('NEW_DASHBOARD.hide_graph'),
                    icon: (
                        <ComboChart class="metric-icon" v-view-box></ComboChart>
                    ),
                    hasEditBtn: false,
                    hasSwitch: true,
                    isSwitchActive: hideGraph,
                    onClick: () => {
                        this.$emit('update', !hideGraph);
                    },
                })}
            </C.ComponentWrapper>
        );
    },
};

export default OnOffSetting;
